'use memo'

import {
  FormCondition,
  SpecialConditionData,
} from '@urbanx/agx.campaigns.client'
import { AgxFinanceCondition } from '@urbanx/agx.ui-components2'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import { useEffect } from 'react'
import {
  FINANCE_CONDITION_STEP_NAME,
  isFinanceConditionComplete,
} from './ContractComplianceHelper'

const EMPTY_SPECIAL_CONDITIONS: SpecialConditionData[] = []

interface ContractComplianceFinanceConditionProps extends TaskModalPageProps {
  subjectToFinance?: FormCondition
  specialConditions?: SpecialConditionData[]
  onFinanceConditionValidationErrorChange?: (
    hasValidationError: boolean
  ) => void
  onSubjectToFinanceUpdated?: (
    subjectToFinance: FormCondition | undefined
  ) => void
}

const ContractComplianceFinanceCondition = ({
  campaign,
  onFinanceConditionValidationErrorChange,
  onSubjectToFinanceUpdated,
  specialConditions,
  subjectToFinance,
  task,
  toggleTaskStep,
}: ContractComplianceFinanceConditionProps) => {
  const FINANCE_LABEL = 'Finance'
  const financeConditionStep = task.taskSteps?.find(
    (step) => step.name === FINANCE_CONDITION_STEP_NAME
  )
  const resolvedSpecialConditions =
    specialConditions ?? EMPTY_SPECIAL_CONDITIONS

  const isValid = isFinanceConditionComplete(subjectToFinance)

  useEffect(() => {
    if (!financeConditionStep?.order) return

    if ((financeConditionStep.isCompleted ?? false) !== isValid) {
      toggleTaskStep(financeConditionStep.order, isValid)
    }
  }, [
    financeConditionStep?.isCompleted,
    financeConditionStep?.order,
    isValid,
    toggleTaskStep,
  ])

  return (
    <AgxFinanceCondition
      id="contract-compliance-finance-condition"
      label={FINANCE_LABEL}
      defaultValue={subjectToFinance}
      validate
      campaignId={campaign.campaignId ?? ''}
      specialConditions={resolvedSpecialConditions}
      defaultToNotSubjectToFinance={false}
      onIsValidChange={(isValid) => {
        onFinanceConditionValidationErrorChange?.(
          Boolean(subjectToFinance?.condition) && !isValid
        )
      }}
      onValueChanged={({ value }) => {
        onSubjectToFinanceUpdated?.(value)
      }}
    />
  )
}

export default ContractComplianceFinanceCondition
